// extracted by mini-css-extract-plugin
export default {"editor":"editor__0V8no"};